import React, { useEffect, useState, useCallback } from 'react';

import { InboxPendenciaProps, getInboxPendencias } from '@app/api/naoPrevistos/caixaEntrada';
import {
  GridView,
  SimpleView,
  Widget,
  Table,
  ColumnProps,
  Button
} from '@digital/ui';
import { Tooltip } from 'antd';
import { compareText } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';


const CaixaEntrada = () => {
  const [data, setData] = useState<InboxPendenciaProps[]>([]);
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(() => {
    setLoading(true);
    getInboxPendencias()
      .then((result) => setData(result))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    carregar();

    const onFocus = () => carregar();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [carregar]);

  const handleRedirect = (link: string) => {
    document.location.href = link;
  };

  const columns: ColumnProps<InboxPendenciaProps>[] = [
    {
      title: 'Projeto',
      dataIndex: 'projeto',
      sorter: (a, b) => compareText(a.projeto, b.projeto),
      width: '20%',
      ...mountFormFilterDropDown('projeto', 'Pesquisar'),
    },
    {
      title: 'Solicitante',
      dataIndex: 'solicitante',
      sorter: (a, b) => compareText(a.solicitante, b.solicitante),
      width: '20%',
      ...mountFormFilterDropDown('solicitante', 'Pesquisar'),
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      sorter: (a, b) => compareText(a.responsavel, b.responsavel),
      width: '20%',
      ...mountFormFilterDropDown('responsavel', 'Pesquisar'),
    },
    {
      title: 'Status Solicitação',
      dataIndex: 'statusSolicitacao',
      sorter: (a, b) => compareText(a.statusSolicitacao, b.statusSolicitacao),
      width: '15%',
      ...mountFormFilterDropDown('statusSolicitacao', 'Pesquisar'),
    },
    {
      title: 'Tipo',
      dataIndex: 'tipoPendencia',
      sorter: (a, b) => compareText(a.tipoPendencia, b.tipoPendencia),
      width: '10%',
      render: (value: InboxPendenciaProps['tipoPendencia']) =>
        value === 'VALIDACAO' ? 'Validação' : 'Aprovação',
      filters: [
        { text: 'Validação', value: 'VALIDACAO' },
        { text: 'Aprovação', value: 'APROVACAO' },
      ],
      onFilter: (value, record) => record.tipoPendencia === value,
    },
    {
      title: 'Ações',
      dataIndex: 'acao',
      render: (_, item) => {
        return (
          <Tooltip title="Executar Atividade">
            <Button
              type="link"
              icon="arrows-circled_right_2"
              size="small"
              onClick={() => {
                handleRedirect(`solicitacao/${item.solicitacaoNaoPrevistoId}`);
              }}
            />
          </Tooltip>
        );
      },
      width: '5%',
    },
  ];

  return (
    <SimpleView>
      <GridView>
        <Widget
          title="Lista de atividades pendentes"
          extra={
            <Tooltip title="Atualizar">
              <Button
                type="link"
                icon="arrows-circled_right_2"
                size="small"
                loading={loading}
                onClick={carregar}
              />
            </Tooltip>
          }
        >
          <Table
            rowKey="solicitacaoNaoPrevistoId"
            columns={columns}
            dataSource={data}
            loading={loading}
          />
        </Widget>
      </GridView>
    </SimpleView>
  );
};

export default CaixaEntrada;
